module.exports = __webpack_public_path__ + "static/media/car-detail.0eb30e17.jpg";